<!-- =========================
     DIAGONAL SPLIT (same structure as the landing page hero / login)
========================= -->
<section class="min-vh-100 overflow-hidden position-relative bcx-diagonal-hero bcx-diagonal-hero-auth">
  <div class="position-absolute top-0 start-0 w-100 h-100 bg-black"></div>
  <div class="position-absolute top-0 start-0 w-100 h-100 bcx-diagonal-white"></div>

  <div v-if="success_message" class="toast-container position-fixed bottom-0 end-0 p-3" aria-live="polite" aria-atomic="true">
    <div class="toast show align-items-center text-white border-0 shadow-lg auth-toast auth-toast-success" role="status">
      <div class="d-flex align-items-center gap-3 p-3">
        <span class="auth-toast-icon rounded-circle d-inline-flex align-items-center justify-content-center flex-shrink-0" aria-hidden="true">
          <i class="bi bi-check2-circle"></i>
        </span>
        <div class="toast-body p-0 fw-semibold lh-sm">{{ success_message }}</div>
        <button type="button" class="btn-close btn-close-white ms-auto flex-shrink-0" aria-label="Dismiss success message" @click="clear_success_message"></button>
      </div>
    </div>
  </div>

  <!-- =========================
       CONTENT — left (white) / right (black), same as hero/login
  ========================== -->
  <div class="container-fluid px-3 px-md-4 px-lg-5 position-relative z-3 min-vh-100 d-flex align-items-center bcx-diagonal-copy">
    <div class="row align-items-center w-100 gy-4">

      <!-- LEFT / WHITE SIDE — branding -->
      <div class="col-12 col-lg-3">
        <router-link to="/" class="auth-logo d-inline-block mb-4" aria-label="BCX Home"></router-link>
        <h1 class="fw-bold display-5 mb-0 bcx-diagonal-line-dark">
          YOU'RE ALL SET.
        </h1>
      </div>

      <!-- RIGHT / BLACK SIDE — confirmation + CTA -->
      <div class="col-12 col-lg-6 offset-lg-3">

        <p class="text-white text-opacity-75 mb-4" style="max-width: 26rem;">
          Your password has been successfully reset. You can now log in using your new credentials.
        </p>

        <router-link
          to="/login"
          class="btn btn-primary bcx-cta-btn text-decoration-none d-inline-flex align-items-center gap-2"
        >
          Go to Login
          <i class="bi bi-arrow-right"></i>
        </router-link>

      </div>

    </div>
  </div>
</section>
